import { useState } from "react";
import { Link } from "react-router-dom";
import type { Post } from "@/mocks/posts";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";
import PostCard from "@/components/feature/PostCard";

interface TodayUpdatesProps {
  posts: Post[];
}

export default function TodayUpdates({ posts }: TodayUpdatesProps) {
  const [activeCat, setActiveCat] = useState<string>("all");

  const availableCats = categories.filter((c) =>
    posts.some((p) => p.categoryId === c.id)
  );
  const filtered =
    activeCat === "all" ? posts : posts.filter((p) => p.categoryId === activeCat);

  return (
    <section id="today" className="w-full px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="每日归档进行中"
        title="新增内容 · 一目了然"
        desc="按发布时间排序，当天新增的条目会持续补充到这里。点击方向标签可以快速筛选，找到你关心的那一条。"
        action={
          <Link
            to="/archive"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-history-line"></i>
            全部归档
          </Link>
        }
      />

      <div className="mt-7 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => setActiveCat("all")}
          className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
            activeCat === "all"
              ? "bg-foreground-950 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
        >
          全部方向
        </button>
        {availableCats.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => setActiveCat(cat.id)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              activeCat === cat.id
                ? "bg-foreground-950 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>

      {filtered.length === 0 && (
        <p className="mt-10 rounded-lg border border-dashed border-background-300 py-12 text-center text-sm text-foreground-500">
          该方向暂时没有新增内容，去归档中心看看吧。
        </p>
      )}
    </section>
  );
}